/* THE SHORE LINE — live Shopify bridge.
   Loads before app.js: merges live Shopify data (price, stock, variant IDs, pairing metafields)
   into the curated design data, then wires the cart, discount codes, checkout, Klaviyo sign-ups,
   back-in-stock and contact form to the real store once app.js has booted. */
(function () {
  'use strict';
  var S = window.TSL_SHOP || {};
  var LIVE = Object.keys(S).length > 0;
  window.TSL_LIVE = LIVE;
  var KLAVIYO_CO = 'RRUyzG', LIST_EMAIL = 'Y8GgNi', LIST_SMS = 'S3LjiQ', KREV = '2024-10-15';
  var POP_DAYS = 7;

  /* ---------- storage (live theme only) ---------- */
  function load(k) { try { var v = localStorage.getItem('tsl_' + k); return v ? JSON.parse(v) : null; } catch (e) { return null; } }
  function save(k, v) { try { localStorage.setItem('tsl_' + k, JSON.stringify(v)); } catch (e) {} }

  /* ---------- merge live product data ---------- */
  function sizeKey(o) { var m = /\u2014\s*(.+)$/.exec(o || ''); return (m ? m[1] : (o || '')).trim(); }
  if (LIVE && window.PRODUCTS) {
    var P = window.PRODUCTS, keep = [];
    P.forEach(function (p) {
      var s = S[p.handle];
      if (!s || !s.available) return; // not on the Online Store, or nothing in stock: leave it off the site
      p.price = s.price / 100;
      p.pid = s.id;
      p.vids = {};
      p.sizes = (p.sizes || []).map(function (row) {
        var c = (s.v || []).filter(function (v) { return sizeKey(v.o1) === row.s; });
        if (!c.length) return { s: row.s, q: 0 };
        var v = c.filter(function (x) { return !x.o2 || /regular/i.test(x.o2); })[0] || c[0];
        p.vids[row.s] = v.id;
        var q = 0;
        if (v.a) q = (v.m && v.pol !== 'continue') ? Math.max(v.q, 1) : Math.max(v.q, 10);
        return { s: row.s, q: q };
      });
      if (s.set && s.set.length) p.set_pieces = s.set;
      if (s.look && s.look.length) p.look_pieces = s.look;
      if (!p.sizes.some(function (x) { return x.q > 0; })) return;
      keep.push(p);
    });
    P.length = 0;
    keep.forEach(function (p) { P.push(p); });
  }

  var T = window.TSL = { load: load, save: save, live: LIVE };
  if (!LIVE) return;

  /* ---------- helpers ---------- */
  function $(s) { return document.querySelector(s); }
  function money(c) { var n = c / 100; return '$' + (n % 1 ? n.toFixed(2) : String(n)); }
  function jpost(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
  }
  var APP = null;

  /* ---------- Klaviyo ---------- */
  function kpost(path, data) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + KLAVIYO_CO, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': KREV }, body: JSON.stringify({ data: data })
    }).catch(function () {});
  }
  T.subscribe = function (email, source) {
    email = (email || '').trim();
    if (!email) return;
    save('email', email);
    save('sub', Date.now());
    try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email }); } catch (e) {}
    return kpost('subscriptions', {
      type: 'subscription',
      attributes: { custom_source: source, profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
      relationships: { list: { data: { type: 'list', id: LIST_EMAIL } } }
    });
  };
  function e164(ph) {
    var d = (ph || '').replace(/[^\d+]/g, '');
    if (/^\+\d{10,15}$/.test(d)) return d;
    d = d.replace(/\D/g, '');
    if (d.length === 10) return '+1' + d;
    if (d.length === 11 && d[0] === '1') return '+' + d;
    return null;
  }
  T.subscribeSms = function (phone, source) {
    var ph = e164(phone);
    if (!ph) return false;
    var attrs = { phone_number: ph, subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } } };
    var em = load('email'); if (em) attrs.email = em;
    kpost('subscriptions', {
      type: 'subscription',
      attributes: { custom_source: source, profile: { data: { type: 'profile', attributes: attrs } } },
      relationships: { list: { data: { type: 'list', id: LIST_SMS } } }
    });
    return true;
  };
  T.notify = function (p, size) {
    var vid = p && p.vids && p.vids[size];
    var email = load('email');
    if (!email) {
      email = window.prompt('Enter your email and we\u2019ll let you know when this size is back:');
      if (!email || !/.+@.+\..+/.test(email)) return true;
      email = email.trim(); save('email', email);
    }
    if (vid) kpost('back-in-stock-subscriptions', {
      type: 'back-in-stock-subscription',
      attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email: email } } } },
      relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + vid } } }
    });
    return false; // let app.js show its confirmation toast
  };

  /* ---------- welcome popup frequency ---------- */
  function fromEmail() { return /[?&](_kx|utm_source=klaviyo|utm_medium=email)/i.test(location.search); }
  if (fromEmail()) save('sub', Date.now());
  T.popAllowed = function () {
    if (load('sub')) return false;
    var t = load('pop');
    return !(t && Date.now() - t < POP_DAYS * 864e5);
  };
  T.popShown = function () { save('pop', Date.now()); };

  /* ---------- contact form -> Shopify ---------- */
  T.contactSubmit = function (form) {
    var g = function (n) { var el = form.querySelector('[name="' + n + '"]'); return el ? el.value.trim() : ''; };
    var topicEl = form.querySelector('[name="topic"]');
    var topic = topicEl ? topicEl.options[topicEl.selectedIndex].text : '';
    var f = document.createElement('form');
    f.method = 'post'; f.action = '/contact#contact_form'; f.style.display = 'none';
    var add = function (n, v) { var i = document.createElement('input'); i.type = 'hidden'; i.name = n; i.value = v; f.appendChild(i); };
    add('form_type', 'contact'); add('utf8', '\u2713');
    add('contact[name]', g('name')); add('contact[email]', g('email'));
    add('contact[topic]', topic); add('contact[order_number]', g('order'));
    add('contact[body]', g('message'));
    document.body.appendChild(f);
    f.submit();
  };

  /* ---------- cart <-> Shopify ---------- */
  var server = {};          // variant id -> qty in the Shopify cart
  var serverCart = null;
  var busy = false, again = false, timer = null, quiet = false;
  function lineVid(l) { return l.vid || (l.p && l.p.vids && l.p.vids[l.size]); }
  function wanted() {
    var d = {};
    APP.cart().forEach(function (l) { var v = lineVid(l); if (v) d[v] = (d[v] || 0) + l.q; });
    return d;
  }
  function sizeFromVariant(p, vid) {
    var k = null;
    Object.keys(p.vids || {}).forEach(function (s) { if (String(p.vids[s]) === String(vid)) k = s; });
    return k;
  }
  function rebuildFrom(c) {
    var lines = [];
    (c.items || []).forEach(function (it) {
      var p = APP.byHandle(it.handle), sz = p && sizeFromVariant(p, it.variant_id);
      if (p && sz) {
        var ex = lines.filter(function (l) { return l.p === p && l.size === sz; })[0];
        if (ex) ex.q += it.quantity; else lines.push({ p: p, size: sz, q: it.quantity });
      } else {
        lines.push({ vid: it.variant_id, size: (it.variant_title || '').replace(/^.*\u2014\s*/, '') || 'One size', q: it.quantity,
          p: { handle: it.handle, title: it.product_title, color: '', price: it.original_price / 100, img: it.image || '', sizes: [] } });
      }
    });
    quiet = true;
    try { APP.setCart(lines); } finally { quiet = false; }
  }
  function sameAsServer() {
    var d = wanted(), ok = true;
    Object.keys(d).forEach(function (v) { if ((server[v] || 0) !== d[v]) ok = false; });
    Object.keys(server).forEach(function (v) { if (!(v in d) && server[v]) ok = false; });
    return ok;
  }
  function paintTotals() {
    var c = serverCart;
    if (!c) return;
    var auto = 0, code = 0, codeName = '';
    (c.items || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (a) {
        var app = a.discount_application || {};
        if (app.type !== 'discount_code') auto += a.amount; else { code += a.amount; codeName = codeName || app.title; }
      });
    });
    (c.cart_level_discount_applications || []).forEach(function (a) {
      if (a.type !== 'discount_code') auto += a.total_allocated_amount; else { code += a.total_allocated_amount; codeName = codeName || a.title; }
    });
    if (!c.item_count) return;
    $('#cartSub').textContent = money(c.original_total_price);
    $('#autoRow').style.display = auto ? '' : 'none';
    if (auto) $('#cartAuto').textContent = '\u2212' + money(auto);
    $('#discRow').style.display = code ? '' : 'none';
    if (code) { $('#discName').textContent = codeName; $('#cartDisc').textContent = '\u2212' + money(code); }
    $('#cartTotal').textContent = money(c.total_price);
  }
  function refresh() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        serverCart = c; server = {};
        (c.items || []).forEach(function (it) { server[it.variant_id] = (server[it.variant_id] || 0) + it.quantity; });
        var codes = (c.discount_codes || []).filter(function (d) { return d.applicable; });
        var cur = APP.discount();
        if (codes.length && (!cur || cur.code !== codes[0].code.toUpperCase())) { quiet = true; try { APP.setDiscount({ code: codes[0].code.toUpperCase(), pct: codePct(codes[0].code) }); } finally { quiet = false; } }
        if (!sameAsServer()) rebuildFrom(c);
        paintTotals();
        return c;
      });
  }
  function sync() {
    if (busy) { again = true; return Promise.resolve(); }
    busy = true;
    var d = wanted(), adds = [], upd = {}, nUpd = 0;
    Object.keys(d).forEach(function (v) {
      var cur = server[v] || 0;
      if (d[v] > cur) adds.push({ id: +v, quantity: d[v] - cur });
      else if (d[v] < cur) { upd[v] = d[v]; nUpd++; }
    });
    Object.keys(server).forEach(function (v) { if (!(v in d)) { upd[v] = 0; nUpd++; } });
    var chain = Promise.resolve();
    if (nUpd) chain = chain.then(function () { return jpost('/cart/update.js', { updates: upd }); });
    if (adds.length) chain = chain.then(function () {
      return jpost('/cart/add.js', { items: adds }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { APP.toast((e && (e.description || e.message)) || 'That size just sold out'); });
      });
    });
    return chain.catch(function () {}).then(refresh).catch(function () {}).then(function () {
      busy = false;
      if (again) { again = false; return sync(); }
    });
  }
  T.cartChanged = function () {
    if (!APP || quiet) return;
    clearTimeout(timer);
    timer = setTimeout(sync, 200);
  };
  function codePct(c) { c = (c || '').toUpperCase(); return /^WELCOME10/.test(c) ? 10 : /^WELCOME15$/.test(c) ? 15 : 0; }
  T.applyCode = function (code, silent) {
    var msg = $('#discMsg');
    code = (code || '').trim().toUpperCase();
    if (!code) { quiet = true; APP.setDiscount(null); quiet = false; jpost('/cart/update.js', { discount: '' }).then(refresh); if (msg && !silent) { msg.textContent = 'Enter a code to apply it.'; msg.className = 'disc__msg is-err'; } return; }
    var go = function () {
      return jpost('/cart/update.js', { discount: code }).then(function (r) { return r.json(); }).then(function (c) {
        var hit = (c.discount_codes || []).filter(function (d) { return (d.code || '').toUpperCase() === code; })[0];
        if (hit && hit.applicable) {
          quiet = true; APP.setDiscount({ code: code, pct: codePct(code) }); quiet = false;
          if (msg && !silent) { msg.textContent = code + ' applied' + (codePct(code) ? ' \u2014 ' + codePct(code) + '% off your first order.' : '.'); msg.className = 'disc__msg is-ok'; }
        } else if (!APP.cart().length && codePct(code)) {
          // empty bag: keep the code on the cart, Shopify applies it once something is added
          quiet = true; APP.setDiscount({ code: code, pct: codePct(code) }); quiet = false;
          if (msg && !silent) { msg.textContent = code + ' will apply at checkout.'; msg.className = 'disc__msg is-ok'; }
        } else {
          quiet = true; APP.setDiscount(null); quiet = false;
          jpost('/cart/update.js', { discount: '' });
          if (msg && !silent) {
            msg.textContent = 'That code isn\u2019t valid.';
            msg.className = 'disc__msg is-err';
          }
        }
        return refresh();
      });
    };
    return (busy ? sync() : Promise.resolve()).then(go).catch(function () {});
  };
  T.checkout = function () {
    var b = $('#checkoutBtn');
    if (b) { b.disabled = true; b.style.opacity = '.6'; }
    clearTimeout(timer);
    var d = APP.discount();
    sync().then(function () {
      location.href = '/checkout' + (d && d.code ? '?discount=' + encodeURIComponent(d.code) : '');
    });
  };

  /* ---------- retire Klaviyo's popup forms (desktop UuHxfZ, mobile Tw3sHU, any flyout) ---------- */
  var KL_MODAL = 'div[aria-label="POPUP Form"],div[aria-label="FULLSCREEN Form"],div[aria-label="FLYOUT Form"],[class*="kl-teaser-"]';
  function killOldPopup() {
    var n = document.querySelectorAll(KL_MODAL);
    if (!n.length) return;
    n.forEach(function (el) { el.remove(); });
    document.body && document.body.classList.remove('klaviyo-prevent-body-scrolling');
  }
  if (window.MutationObserver) new MutationObserver(killOldPopup).observe(document.documentElement, { childList: true, subtree: true });

  /* ---------- boot (called at the end of app.js) ---------- */
  window.TSL_BOOT = function (app) {
    APP = app;
    var html = document.documentElement;
    // which Shopify template rendered this URL
    var mk = document.querySelector('[data-tsl-route]');
    var tpl = mk ? mk.getAttribute('data-tsl-route') : '';
    var path = location.pathname.replace(/\/$/, '');
    var handled = document.body.classList.contains('has-view');
    if (!handled && path) {
      if (tpl === 'product' || tpl === 'collection' || tpl === 'list-collections') {
        location.replace('/collections/shop'); return;
      }
      if (tpl === 'search') {
        var qm = /[?&]q=([^&]*)/.exec(location.search);
        setTimeout(function () {
          var b = $('#openSearch'); if (b) b.click();
          var i = $('#searchInput');
          if (i && qm) { i.value = decodeURIComponent(qm[1].replace(/\+/g, ' ')); i.dispatchEvent(new Event('input')); }
        }, 50);
      } else if (tpl !== 'index' && tpl !== 'cart' && tpl !== '404') {
        // Shopify-rendered content (custom pages, policies, gift cards …)
        html.classList.add('tsl-native');
      }
    }
    html.classList.remove('tsl-sub');
    // welcome teaser keeps its state between pages
    if (load('pop') && !load('sub') && !load('tabx')) { var st = $('#sideTab'); if (st) st.classList.add('is-on'); }
    if (/[?&]contact_posted=true/.test(location.search)) { var ok = $('#contactOk'); if (ok) ok.hidden = false; }
    refresh().then(function () {
      if (path === '/cart') app.open('#cartDrawer');
    }).catch(function () {});
  };
})();
